import React, {useEffect} from 'react';
import {Container} from 'react-bootstrap';
import {ProjectModal} from '../components/ProjectModal';
import {NavigationBar} from '../components/NavigationBar';
import {FloattingButtons} from '../components/FloattingButtons';
import {Landingview} from '../components/Landingview';
import {MissionAndVision} from '../components/MissionAndVision';
import {Kpi} from '../components/Kpi';
import {Timeline} from '../components/Timeline';
import {Team} from '../components/Team';
import {Machines} from '../components/Machines';
import {VirtualTour} from '../components/VirtualTour';
import {Map} from '../components/Map';
import {ContactForm} from '../components/ContactForm';
import {Footer} from '../components/Footer';
import '../styles/pages/pages.css';

export const Aboutus = () => {

    useEffect(() => {
        document.title = "Conócenos - FabLab UTFSM";
    });

    return(
        <Container className="fablab-page" fluid>
            <ProjectModal/>     
            <NavigationBar/>
            <FloattingButtons/>
            <Landingview/>
            <MissionAndVision/>
            <Kpi/>
            <Timeline/>
            <Team/>
            <Machines/>
            {/* <VirtualTour/> */}
            <Map/>
            <ContactForm/>
            <Footer/>
        </Container>
    )

}